<template>
  <div class="footer">
    <div class="container">
      <div class="footer_top">
        <div class="contain clearfix">
          <div class="footer_top_list">
            <div class="footer_top_list_title">
              <span>DOA/Handle中国运营管理机构</span><br/>
              <span class="wgTitle">网根科技（北京）有限公司</span>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_title">
                <span>咨询热线：</span>
              </div>
              <div class="list_con_con">
                <span>+86 010-68618216</span>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_title">
                <span>技术支持：</span>
              </div>
              <div class="list_con_con">
                <span>+86 010-68618216</span>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_title">
                <span>投诉电话：</span>
              </div>
              <div class="list_con_con">
                <span>+86 010-68618216</span>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_title">
                <span>电子邮件：</span>
              </div>
              <div class="list_con_con">
                <span>lim@mpacn.net</span>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_title">
                <span>地 址：</span>
              </div>
              <div class="list_con_con">
                <span>北京市石景山区鲁谷路35号 电科大厦13层</span>
              </div>
            </div>
          </div>
          <div class="footer_top_list">
            <div class="footer_top_list_title">
              <span>友情链接</span>
            </div>

            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <a href="http://www.itu.int/" target="_blank">国际电信联盟(ITU)</a>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <a href="https://www.cdi.cn/" target="_blank">北京中数创新科技股份有限公司(CDI)</a>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <a href="https://www.cndona.com.cn/" target="_blank">北京西恩多纳信息技术有限公司(CHC)</a>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <a href="https://www.dona.net/" target="_blank">数字对象规范命名机构(DONA)</a>
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <a href="http://doa-atsd.net/" target="_blank">数字对象体系架构应用技术与标准促进组织(ATSD)</a>
              </div>
            </div>
          </div>
          <div class="footer_top_list">
            <div class="footer_top_list_title">
              <span>关于我们</span>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <router-link :to="{name: 'zh-NetRootBJ'}">网根科技（北京）有限公司</router-link>
                <!-- <a href="https://www.mpacn.net/" target="_blank">网根科技（北京）有限公司</a> -->
              </div>
            </div>
            <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <router-link :to="{name: 'Home'}">MPA联合体</router-link>
                <!-- <a href="https://www.mpacn.net/" target="_blank">MPA联合体</a> -->
              </div>
            </div>
            <!-- <div class="footer_top_list_con clearfix">
              <div class="list_con_con">
                <router-link :to="{name: 'zh-company'}">DONA基金会</router-link>
              </div>
            </div> -->
            <div class="footer_top_list_con clearfix">
              <div class="img">
                <img src="./../assets/img/MPAerweima.jpg" alt="MPA联合体" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bootom">
        <div class="contain">
          <div class="footer_bootom_top">
            <div class="footer_bootom_list_con clearfix">
              <div class="list_con_title">
                <span>相关文件：</span>
              </div>
              <div class="list_con_con">
                <router-link :to="{name: 'zh-documents-01'}">Handle系统简介</router-link>
                <router-link :to="{name: 'zh-documents-02'}">Handle编码说明图示</router-link>
                <router-link :to="{name: 'zh-documents-03'}">Handle编码说明及使用规范</router-link>
                <router-link :to="{name: 'zh-documents-04'}">Handle前缀管理规定</router-link>
                <router-link :to="{name: 'zh-documents-05'}">MPA联合体组织架构说明</router-link>
                <router-link :to="{name: 'zh-documents-06'}">工业互联网Handle国际根节点运营机制</router-link>
                <router-link :to="{name: 'zh-documents-07'}">工业互联网Handle国际根节点管理机制</router-link>
              </div>
            </div>
          </div>
          <div class="footer_bootom_bottom">
            <a href="https://beian.miit.gov.cn/Integrated/recordQuery#/Integrated/recordQuery" style="display: block;" target="_blank">
              <p>Copyright © MPA联合体 All rights reserved. 京ICP备2022006716号-1</p>
            </a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010702002349" target="_blank"><i>京公网安备 11010702002349号</i></a>
            <br/>
            <a href="https://xyt.xcc.cn/getpcInfo?sn=1854875424916467712&language=CN&certType=8&url=*.mpacn.net" target="_blank" style="position: relative;display: inline-block;height: 38px;margin-top: 14px;">
              <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
              <embed src="https://program.xinchacha.com/web/1854875424916467712=*.mpacn.net.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="less">
@black_16: #292929;
.footer {
  // margin-top: 80px;
  width: 100%;
  height: 510px;
  background-color: @black_16;
  .footer_top {
    padding: 30px 0;
    width: 100%;
    height: 370px;
    .footer_top_list {
      padding: 0 18px;
      float: left;
      width: calc(100% / 3);
      height: 300px;
      border-right: 1px solid #3e3e3e;
      .footer_top_list_title {
        margin-bottom: 18px;
        font-size: 18px;
        line-height: 24px;
        color: #ffffff;
        text-align: left;
        .wgTitle {
          font-size: 16px;
          line-height: 26px;
        }
      }
      .footer_top_list_con {
        .list_con_title {
          padding: 6px 0;
          float: left;
          font-size: 14px;
          line-height: 20px;
          color: #b7b7b7;
          text-align: left;
        }
        .list_con_con {
          padding: 6px 0;
          float: left;
          width: calc(100% - 100px);
          font-size: 14px;
          line-height: 20px;
          color: #797979;
          text-align: left;
          span {
            display: block;
          }
        }
        .img {
          margin-top: 15px;
          width: 140px;
          height: 140px;
          background-color: #2f2f2f;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .footer_top_list:nth-child(2),
    .footer_top_list:nth-child(3) {
      .list_con_con {
        float: left;
        width: calc(100% - 0px);
        text-align: left;
        a {
          display: block;
          font-size: 14px;
          line-height: 18px;
          color: #797979;
        }
        a:hover {
          color: #605f5f;
        }
      }
    }
    .footer_top_list:last-child {
      border: none;
    }
  }
  .footer_bootom {
    width: 100%;
    height: calc(550px - 296px);
    background-color: #1e1e1e;
    .footer_bootom_top {
      padding: 18px 0;
      border-bottom: 1px solid #3e3e3e;
      .footer_bootom_list_con {
        padding: 4px 0px;
        .list_con_title {
          float: left;
          font-size: 14px;
          line-height: 20px;
          color: #b7b7b7;
          text-align: left;
        }
        .list_con_con {
          float: left;
          width: auto;
          text-align: left;
          a {
            margin-right: 30px;
            display: inline-block;
            font-size: 14px;
            line-height: 18px;
            color: #797979;
          }
          a:hover {
            color: #605f5f;
          }
        }
      }
    }
    .footer_bootom_bottom {
      padding: 20px 0;
      text-align: center;
      p {
        margin: 0 auto;
        display: block;
        font-size: 14px;
        line-height: 18px;
        color: #666666;
      }
      i {
        padding-left: 28px;
        margin: 0 auto;
        display: inline-block;
        font-size: 14px;
        line-height: 18px;
        color: #666666;
        font-style: normal;
        background: url("./../assets/img/put-on-record.png") no-repeat
          left center;
      }
      a {
        padding-left: 35px;
        margin: 0 auto;
        display: inline-block;
        font-size: 14px;
        line-height: 18px;
        color: #666666;
        font-style: normal;
      }
    }
  }
}
@media all and (max-width: 768px) {
  .footer {
    width: 100%;
    height: auto;
    background-color: @black_16;
    .footer_top {
      padding: 30px 0;
      width: 100%;
      height: auto;
      .footer_top_list {
        padding: 0 20px;
        float: left;
        width: calc(100%);
        height: 300px;
        border-right: 1px solid #3e3e3e;
        .footer_top_list_title {
          margin-bottom: 18px;
          font-size: 18px;
          line-height: 24px;
          color: #ffffff;
          text-align: left;
        }
        .footer_top_list_con {
          .list_con_title {
            padding: 6px 0;
            float: left;
            font-size: 14px;
            line-height: 20px;
            color: #b7b7b7;
            text-align: left;
          }
          .list_con_con {
            padding: 6px 0;
            float: left;
            width: calc(100% - 80px);
            font-size: 14px;
            line-height: 20px;
            color: #797979;
            text-align: left;
            span {
              display: block;
            }
          }
        }
      }
      // .footer_top_list:nth-child(2),
      // .footer_top_list:nth-child(3){
      //   display: none;
      // }
      // .footer_top_list:last-child{
      //   border: none;
      // }
    }
    .footer_bootom {
      width: 100%;
      height: auto;
      background-color: #1e1e1e;
      .footer_bootom_top {
        display: none;
      }
      .footer_bootom_bottom {
        padding: 20px 12%;
        text-align: center;
        p {
          margin: 0 auto;
          display: block;
          font-size: 14px;
          line-height: 18px;
          color: #666666;
          text-align: center;
        }
        i {
          padding-left: 28px;
          margin: 0 auto;
          display: inline-block;
          font-size: 14px;
          line-height: 18px;
          color: #666666;
          font-style: normal;
          // background: url("./../assets/img/put-on-record.png") no-repeat left center;
        }
        a {
          padding-left: 0;
          margin: 0 auto;
          display: inline-block;
          font-size: 14px;
          line-height: 18px;
          color: #666666;
          font-style: normal;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/HomeFooter.vue